import axios from 'axios';
import { urlsServices } from '../configs/urlsConfigAppBase';

const api = axios.create({
    baseURL: urlsServices.BACKENDWS,
    timeout: 900000, // 15 minutos
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para lidar com erros de resposta (ex: token expirado)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Token expirado ou inválido, redirecionar para login ou limpar storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            // window.location.href = '/login'; // Opcional: forçar redirecionamento
        }
        return Promise.reject(error);
    }
);

export default api;
